import { API_BASE_URL, API_FETCH_ORG_USERS_DATA_PATH } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';

export interface OrgUsersData {
    orgName: string;
    orgLicenseStatus: string;
    userData: {
        studentName: string;
        email: string;
        classRoomName: string | null;
        lastLogin: string | null; // ISO date string
        dateJoined: string; // ISO date string
        lastExamDate: string | null; // ISO date string
        userRole: string;
    }[];
}

async function executeGetFetchOrgUserDataWithToken(accessToken: string | null): Promise<OrgUsersData> {
    return axios
        .get(
            API_BASE_URL + API_FETCH_ORG_USERS_DATA_PATH,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
        })
        .catch(error => {
            if (error.response && error.response.status === 401) {
                console.log("not authenticated");
            } else if (error.response && error.response.status === 400) {
                console.log("user does not belong to any org or does not have permission to view this data");
                // } else if (error.response && error.response.status === 404) {
                //     console.log("no users found"); // for now vacant return will be handled as 200
            } else {
                console.error('Error during fetching:', error);
            }
            return Promise.reject(error);
        });
}

export default async function autoRefreshedExecuteGetFetchOrgUserDataWithToken(accessToken: string | null): Promise<OrgUsersData> {
    return executeGetFetchOrgUserDataWithToken(accessToken)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeGetFetchOrgUserDataWithToken(refreshedAccessToken);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
